<div class="margin-top-lg">
	<mat-accordion>
		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title class="italic"
					[ngClass]="{'danger': studentTerminationStatuses.length > 0 && studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1
					, 'primary': studentTerminationStatuses.length > 0 && studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID === 1}">
					{{studentTerminationStatuses.length > 0 ?
					studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.ID !== 1 ? 'Terminated: '
					: '' : ''}}
					{{studentTerminationStatuses.length > 0 ?
					studentTerminationStatuses[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE + ': ' :
					''}}
					{{(studentTerminationStatuses.length > 0 ?
					studentTerminationStatuses[0].STATUS_DATE :
					'') | cleanDate | simpleDate}}
				</mat-panel-title>
				<mat-panel-description class="black">
					{{studentTerminationStatuses.length > 0 ? 'Created By: ' + studentTerminationStatuses[0].CREATED_BY
					: 'Open to Terminate Child'}}{{studentTerminationStatuses.length > 0 &&
					studentTerminationStatuses[0].CREATED_DATE ? ': ' : ''}}
					{{(studentTerminationStatuses.length > 0 ? studentTerminationStatuses[0].CREATED_DATE : '')
					| cleanDate | simpleDate}}
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="margin-bottom-lg">
				<mat-card-title>
					Termination History
				</mat-card-title>
				<mat-divider> </mat-divider>

				<div class="margin-top-md">
					<mat-table [dataSource]="tableDataSource" class="table-responsive mat-elevation-z1" matSort>
						<form [formGroup]="editingForm">
							<ng-container matColumnDef="EDIT">
								<mat-header-cell *matHeaderCellDef> </mat-header-cell>
								<mat-cell *matCellDef="let element">
									<div>
										<confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
											[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
											[popoverConfirmColor]="'warn'" [tooltip]="'Delete'"
											(onConfirm)="deleteStudentTerminationStatus(element)" *ngIf="
											element.ID > 0 
											? element.STUDENT_TERMINATION_STATUS_GRADUATIONS 
											? element.STUDENT_TERMINATION_STATUS_GRADUATIONS.length > 0 
											? element.STUDENT_TERMINATION_STATUS_GRADUATIONS[0].ID 
											: false 
											: false
											: true">
										</confirm-popover>
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="STATUS_DATE">
								<mat-header-cell *matHeaderCellDef> Termination Date </mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'danger': element.STUDENT_TERMINATION_STATUS_TYPES.ID !== 1, 'primary': element.STUDENT_TERMINATION_STATUS_TYPES.ID === 1}">
									<div>
										{{(element.STATUS_DATE) | cleanDate | simpleDate}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="STUDENT_TERMINATION_STATUS_TYPES.TYPE">
								<mat-header-cell *matHeaderCellDef> Reason </mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'danger': element.STUDENT_TERMINATION_STATUS_TYPES.ID !== 1, 'primary': element.STUDENT_TERMINATION_STATUS_TYPES.ID === 1}">
									<div>
										{{element.STUDENT_TERMINATION_STATUS_TYPES.TYPE}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CREATED_BY">
								<mat-header-cell *matHeaderCellDef> Created By </mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'danger': element.STUDENT_TERMINATION_STATUS_TYPES.ID !== 1, 'primary': element.STUDENT_TERMINATION_STATUS_TYPES.ID === 1}">
									<div>
										{{element.CREATED_BY}}
									</div>
								</mat-cell>
							</ng-container>

							<ng-container matColumnDef="CREATED_DATE">
								<mat-header-cell *matHeaderCellDef> Created On </mat-header-cell>
								<mat-cell *matCellDef="let element"
									[ngClass]="{'danger': element.STUDENT_TERMINATION_STATUS_TYPES.ID !== 1, 'primary': element.STUDENT_TERMINATION_STATUS_TYPES.ID === 1}">
									<div>
										{{element.CREATED_DATE | cleanDate | simpleDate}}
									</div>
								</mat-cell>
							</ng-container>
						</form>

						<ng-container matColumnDef="ADD" disabled>
							<mat-header-cell *matHeaderCellDef>
								<div *ngIf="!adding">
									<button mat-raised-button color="primary"
										(click)="addStudentTerminationStatus()">New Termination</button>
								</div>
							</mat-header-cell>
						</ng-container>

						<form [formGroup]="editingForm">
							<ng-container matColumnDef="ADD_EDIT" disabled>
								<mat-header-cell *matHeaderCellDef>
									<div *ngIf="adding">
										<confirm-popover [buttonType]="'mini-icon'" [icon]="'add'" [color]="'primary'"
											[popoverMsg]="'Add new Termination'" [popoverConfirmText]="'Add'"
											[popoverConfirmColor]="'primary'" [tooltip]="'Add'"
											(onConfirm)="confirmAddStudentTerminationStatus()"
											[disabled]="!editingForm.valid">
										</confirm-popover>
										<confirm-popover [buttonType]="'mini-icon'" [icon]="'close'" [color]="'warn'"
											[popoverMsg]="'Cancel?'" [popoverConfirmText]="'Yes'"
											[popoverCancelText]="'No'" [popoverConfirmColor]="'primary'"
											[tooltip]="'Cancel'" (onConfirm)="cancelAddStudentTerminationStatus()">
										</confirm-popover>
									</div>
								</mat-header-cell>
							</ng-container>

							<ng-container matColumnDef="ADD_STATUS_DATE">
								<mat-header-cell *matHeaderCellDef class="row">
									<div class="col">
										<div class="row">
											<mat-form-field>
												<mat-label>
													Termination Date
												</mat-label>
												<input matInput formControlName="terminationDate"
													[matDatepicker]="dobPicker" (click)="dobPicker.open()">
												<mat-datepicker-toggle matSuffix
													[for]="dobPicker"></mat-datepicker-toggle>
												<mat-datepicker #dobPicker></mat-datepicker>
											</mat-form-field>
										</div>
									</div>
								</mat-header-cell>
							</ng-container>

							<ng-container matColumnDef="ADD_STUDENT_TERMINATION_STATUS_TYPES.TYPE">
								<mat-header-cell *matHeaderCellDef class="row">
									<div class="col">
										<div class="row">
											<mat-form-field class="mat-form-field-padding">
												<mat-label>
													Reason
												</mat-label>
												<mat-select formControlName="terminationReason"
													(selectionChange)="checkTerminationStatusType()">
													<mat-option
														*ngFor="let studentTerminationStatusType of studentTerminationStatusTypes"
														[value]="studentTerminationStatusType"
														[disabled]="studentTerminationStatusType.SELECTABLE === 0">
														{{studentTerminationStatusType.TYPE}}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
									</div>
									<div class="col">
										<div class="row">
											<mat-form-field class="mat-form-field-padding"
												*ngIf="schoolEnrollmentRequired">
												<mat-label>
													School Enrollment
												</mat-label>
												<mat-select formControlName="terminationGraduationEnrollment">
													<mat-option
														*ngFor="let schoolEnrollment of schoolEnrollments | orderBy: 'SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR' : 'desc'
															| orderBy: 'SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE' : 'desc'"
														[value]="schoolEnrollment">
														{{'[Region ' + schoolEnrollment.REGION.CODE + '] - ' +
														schoolEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR + ':
														' +
														schoolEnrollment.SCHOOL.NAME + ' (' +
														schoolEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE + '/' +
														schoolEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE +
														')'}}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
										<div *ngIf="schoolEnrollmentRequired && schoolEnrollments.length === 0">
											{{'* Cannot add ' +
											getFormValue('terminationReason', 'TYPE')
											+ ', no available enrollments found.'}}</div>
									</div>
								</mat-header-cell>
							</ng-container>
						</form>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matHeaderRowDef="newDisplayedColumns"
							[hidden]="studentTerminationStatusFound || !editing"></mat-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
					</mat-table>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>